"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Util_1 = require("../../../../../Services/Util");
var AuthenticationService_1 = require("../../../../../Services/AuthenticationService");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Components_1 = require("../../../../../Components");
function DeleteLocationEvent(locationName, updateCallback, resources) {
    var deleteLocationEventContentRef = React.createRef();
    return new Types_1.VeriLiteWarningEvent(React.createElement(DeleteLocationEventContent, { ref: deleteLocationEventContentRef, locationName: locationName, updateCallback: updateCallback, resources: resources }), resources.ConfirmDeleteTitle, [
        new Types_1.VeriLiteEventAction(resources.Delete, "danger", function (currentEvent, closeModalCallback) {
            var _a;
            (_a = deleteLocationEventContentRef.current) === null || _a === void 0 ? void 0 : _a.deleteLocation();
        }), new Types_1.VeriLiteEventAction(resources.Close, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]);
}
exports.DeleteLocationEvent = DeleteLocationEvent;
var InputValidationState;
(function (InputValidationState) {
    InputValidationState[InputValidationState["unset"] = 0] = "unset";
    InputValidationState[InputValidationState["invalid"] = 1] = "invalid";
    InputValidationState[InputValidationState["valid"] = 2] = "valid";
})(InputValidationState || (InputValidationState = {}));
var DeleteLocationEventContentState;
(function (DeleteLocationEventContentState) {
    DeleteLocationEventContentState[DeleteLocationEventContentState["Initial"] = 0] = "Initial";
    DeleteLocationEventContentState[DeleteLocationEventContentState["Pending"] = 1] = "Pending";
    DeleteLocationEventContentState[DeleteLocationEventContentState["Success"] = 2] = "Success";
})(DeleteLocationEventContentState || (DeleteLocationEventContentState = {}));
var DeleteLocationEventContent = /** @class */ (function (_super) {
    __extends(DeleteLocationEventContent, _super);
    function DeleteLocationEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.isValid = function (input) {
            return input === InputValidationState.valid;
        };
        _this.isInvalid = function (input) {
            return input === InputValidationState.invalid;
        };
        _this.clearValidation = function () {
            _this.setState({
                ValidationState: InputValidationState.unset
            });
        };
        _this.validateInput = function () {
            if (!(_this.state.locationName === undefined || _this.state.locationName === null || _this.state.locationName === "") && _this.state.locationName === _this.props.locationName.toUpperCase()) {
                _this.setState({
                    ValidationState: InputValidationState.valid
                });
                return true;
            }
            else {
                _this.setState({
                    ValidationState: InputValidationState.invalid
                });
                return false;
            }
        };
        _this.onChangeHandler = function (event) {
            _this.setState({
                locationName: event.target.value
            });
        };
        _this.deleteLocation = function () { return __awaiter(_this, void 0, void 0, function () {
            var options, userRequestHeaders, headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearValidation();
                        if (!this.validateInput()) {
                            return [2 /*return*/];
                        }
                        this.updateModal(DeleteLocationEventContentState.Pending);
                        options = {};
                        options = Object.assign(__assign({}, Util_1.defaultDeleteOptions), options);
                        userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                        headers = new Headers(options.headers);
                        return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                    case 1:
                        _a.sent();
                        userRequestHeaders.AppendHeaders(options);
                        fetch("/api/Location/Delete?location=" + this.props.locationName, options).then(function (response) {
                            if (!response.ok) {
                                _this.updateModal(DeleteLocationEventContentState.Initial);
                                response.json().then(function (errorResponse) {
                                    console.error(errorResponse);
                                });
                            }
                            else {
                                _this.updateModal(DeleteLocationEventContentState.Success);
                            }
                        }).catch(function (err) {
                            console.error("Error deleteing location:");
                            console.error(err);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            switch (newState) {
                case DeleteLocationEventContentState.Success:
                    _this.props.updateCallback();
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case DeleteLocationEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.LoadingDotDotDot;
                    event.actions = [];
                    eventHandler.UpdateEvent();
                    break;
                case DeleteLocationEventContentState.Initial:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.ConfirmDeleteTitle;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Delete, "danger", function (currentEvent, closeModalCallback) {
                            _this.deleteLocation();
                        }), new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
            }
        };
        _this.stateBasedRender = function (currentState) {
            switch (currentState) {
                case DeleteLocationEventContentState.Initial:
                    return (React.createElement("div", null,
                        _this.props.resources.DeleteLocationMessage,
                        React.createElement(reactstrap_1.Input, { valid: _this.isValid(_this.state.ValidationState), invalid: _this.isInvalid(_this.state.ValidationState), placeholder: _this.props.locationName.toUpperCase(), onChange: _this.onChangeHandler })));
                case DeleteLocationEventContentState.Pending:
                    return (React.createElement(Components_1.CustomSpinner, null));
                case DeleteLocationEventContentState.Success:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.props.resources.DeleteLocationSuccess),
                            React.createElement(reactstrap_1.Col, null))));
            }
        };
        _this.state = {
            locationName: "",
            ValidationState: InputValidationState.unset,
            showOverlay: false,
            status: DeleteLocationEventContentState.Initial
        };
        return _this;
    }
    DeleteLocationEventContent.prototype.render = function () {
        return this.stateBasedRender(this.state.status);
    };
    return DeleteLocationEventContent;
}(React.Component));
//# sourceMappingURL=DeleteLocationEvent.js.map